import { IApplicationState } from '../../types/redux';
import { selectNewbuilding } from './selectNewbuilding';

export const selectNewbuildingImage = (state: IApplicationState) => {
  const { imgUrl } = selectNewbuilding(state);

  return imgUrl;
};
